module.exports = __webpack_public_path__ + "img/V4.1dccf0ed.jpg";